module.exports = __webpack_public_path__ + "static/details-4-a200010d0410a31657c89e120899d71f.jpg";